import React, { useState, useEffect } from "react";
import { fetchAsyncInquiry } from "./InquirySlice";
import { useSelector, useDispatch } from "react-redux";
import {
  InquiryInfo,
  InquiryLoading,
  InquiryError,
  InquiryUpdatedTime,
} from "./InquirySlice";
import "../../css/Inquiry.css";
import InquiryIncomplete from "./InquiryIncomplete";
import InquiryComplete from "./InquiryComplete";

const Inquiry: React.FC = () => {
  const dispatch = useDispatch();
  //対応済みか否か
  const [imcomplete, setImcomplete] = useState(true);
  //データにアクセス
  const InquiryInfoData = useSelector(InquiryInfo);
  const InquiryGetTime = useSelector(InquiryUpdatedTime);

  //stateが初期値ならdispatch
  useEffect(() => {
    if (InquiryInfoData["incompleted"] === null) {
      dispatch(fetchAsyncInquiry());
    }
  }, [dispatch]);

  //Enterクリックで更新

  const [valid, setValid] = useState<boolean>(true);
  //セルをクリックでユーザ詳細表示
  const [detailFlag, setDetailFlag] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);


  
  //  モーダルUI
  const Detail = ({ item }: any) => (
    <div className="detail_container">
      name :  {item.family_name + " " + item.first_name}
      <br />
      user_id : {item.user_id}
      <br />
      number : {item.phone_number}
      <br />
      birthday: {item.date_of_birth}
      <br />
      age : {item.age}
      <br />
      register_date : {item.account_creation_date}
      <br />
      status : {item.status}
    </div>
  );
  
  //モーダルを出す
  const handleDetail = (item: any) => {
    setSelectedItem(item);
    setDetailFlag(!detailFlag);
  };

  return (
    <div className="position_row">
      <div className="inquiry_container">
        {detailFlag && <Detail item={selectedItem} />}
        <h1 className="inquiry_title">お問い合わせ一覧</h1>
        <div className="inquiry_button_container">
          <button
            className="inquiry_change_button"
            onClick={() => setImcomplete(true)}>
            未対応
          </button>
          <button
            className="inquiry_change_button"
            onClick={() => setImcomplete(false)}>
            対応済み
          </button>
        </div>
        <div className="time">最終更新時間 : {InquiryGetTime}</div>
        <table className="item_container">
          <thead>
            <tr key={"inquiry_title"} className="inquiry_item_container">
              <td className="box">No.</td>
              <td className="item">ユーザ名</td>
              <td className="item">カテゴリー</td>
              <td className="item">件名</td>
              <td className="item">内容</td>
              <td className="item">お問い合わせ時間</td>
              <td className="item">進捗</td>
              <td className="item">対応</td>
            </tr>
          </thead>
          {/* stateに応じて切り替え */}
          {imcomplete ? (
            <InquiryIncomplete
              data={InquiryInfoData["incompleted"]!}
              detailFlag={detailFlag}
              setDetailFlag={setDetailFlag}
              setSelectedItem={setSelectedItem}
              handleDetail={handleDetail}
            />
          ) : (
            <InquiryComplete
              data={InquiryInfoData["completed"]!}
              detailFlag={detailFlag}
              setDetailFlag={setDetailFlag}
              setSelectedItem={setSelectedItem}
              handleDetail={handleDetail}
            />
          )}
        </table>
      </div>
    </div>
  );
};

export default Inquiry;
